module.exports = __webpack_public_path__ + "static/media/check-single.fd2bc06c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/check-single.svg
// module id = 1236
// module chunks = 0